import { LegacyHome, PersonalizedHome } from './components';
import { useFeatureFlag } from 'src/lib/hooks';

const Home = () => {
  const featurePersonalizedHome = useFeatureFlag('personalized_home');

  if (featurePersonalizedHome) {
    return <PersonalizedHome />;
  }

  if (!featurePersonalizedHome) {
    return <LegacyHome />;
  }
};

export default Home;
